import { motion } from 'framer-motion';
import { Link } from 'gatsby';
import * as React from 'react';

import { RevealTextFromTop, FadeInBottom, FadeInBottomS } from 'animations';
import { getTextWithoutParagraph } from 'utils';

import {
  Wrapper,
  Inner,
  Content,
  Label,
  StyledLabelIcon,
  LabelText,
  StyledTitle,
  StyledButton,
  BottomWrapper,
  BottomText,
  Illustration,
  TriangleWrapper,
  TriangleSvg,
} from './employee-rewards-intro.styles';
import LabelIconSvgUrl from './icons/label-icon.url.svg';
import TriangleImageSvgUrl from './images/triangle.url.svg';
import { LogosBlock } from './logos-block';

const containerAnimationVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const IntroView = (props) => {
  const { labelText, title, buttonLink, buttonText, bottomText, logos, illustration } = props;

  return (
    <Wrapper>
      <Inner>
        <Content>
          <motion.div initial="hidden" animate="visible" variants={containerAnimationVariants}>
            <motion.div variants={FadeInBottomS}>
              <Label>
                <StyledLabelIcon
                  src={LabelIconSvgUrl}
                  width={33}
                  height={32}
                  alt=""
                  loading="lazy"
                />
                <LabelText>{labelText}</LabelText>
              </Label>
            </motion.div>
            <StyledTitle size="xxl">
              {getTextWithoutParagraph(title)
                .split('<br />')
                .map((part, index) => (
                  <motion.div
                    key={`intro-title-${index}`}
                    variants={RevealTextFromTop}
                    dangerouslySetInnerHTML={{ __html: part }}
                  />
                ))}
            </StyledTitle>
            <motion.div variants={FadeInBottom}>
              <StyledButton component={Link} theme="fill" to={buttonLink}>
                {buttonText}
              </StyledButton>
            </motion.div>
          </motion.div>

          <Illustration fixed={illustration} />
          <BottomWrapper>
            <BottomText>{bottomText}</BottomText>
            <LogosBlock items={logos} />
          </BottomWrapper>
        </Content>
      </Inner>

      <TriangleWrapper>
        <TriangleSvg src={TriangleImageSvgUrl} />
      </TriangleWrapper>
    </Wrapper>
  );
};
